import AnimatedResults from './AnimatedResults';
import { calcResultsDimensions } from './dimensions';
import AnimatedResultsOverlay from './AnimatedResultsOverlay';

export { calcResultsDimensions, AnimatedResultsOverlay };

export default AnimatedResults;
